import {
  Component,
  Inject,
  HostBinding,
  ChangeDetectionStrategy,
} from '@angular/core';

import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
} from '@angular/material/snack-bar';
import { ToasterData } from './toaster.service';

@Component({
  selector: 'app-toaster',
  imports: [],
  templateUrl: './toaster.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./toaster.component.scss'],
})
export class ToasterComponent {
  @HostBinding('class') get hostClass(): string {
    return `toaster-component toaster-${this.data.type}`;
  }

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: ToasterData,
    private snackBarRef: MatSnackBarRef<ToasterComponent>,
  ) {}

  close(): void {
    this.snackBarRef.dismiss();
  }

  getIconClass(): string {
    switch (this.data.type) {
      case 'success':
        return 'cm-icons cm-icons-circle-check-solid';
      case 'error':
        return 'cm-icons cm-icons-error-solid';
      case 'warning':
        return 'cm-icons cm-icons-warning-solid';
      case 'info':
      default:
        return 'cm-icons cm-icons-info-solid';
    }
  }

  getAriaLabel(): string {
    return `${this.data.type} notification: ${this.data.message}`;
  }

  getCloseIconColor(): string {
    return 'var(--toaster-close-color)';
  }
}
